import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@kolmeo/ui-core';
const ModalBody = ({ bodyComponent }) => {
    return (_jsx(Box, { paddingY: 16, children: bodyComponent }));
};
export default ModalBody;
